import { render, staticRenderFns } from "./ServiceNow.vue?vue&type=template&id=42c55a70&scoped=true"
import script from "./ServiceNow.vue?vue&type=script&lang=js"
export * from "./ServiceNow.vue?vue&type=script&lang=js"
import style0 from "./ServiceNow.vue?vue&type=style&index=0&id=42c55a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c55a70",
  null
  
)

export default component.exports